import { render, staticRenderFns } from "./talentTable.vue?vue&type=template&id=aab7f69c"
import script from "./talentTable.vue?vue&type=script&lang=js"
export * from "./talentTable.vue?vue&type=script&lang=js"
import style0 from "./talentTable.vue?vue&type=style&index=0&id=aab7f69c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports